import * as JSPM from 'jsprintmanager';

/**
 * For initializing JSPM exe
 */
const initJSPM = async () => {
  // eslint-disable-next-line camelcase
  // JSPM.JSPrintManager.auto_reconnect = true;
  try {
    await JSPM.JSPrintManager.start();
  } catch (error) {
    console.log(error);
  }
};

/**
 * For checking JSPM status
 */
const jspmWSStatus = () => {
  if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
    return true;
  } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
    alert('JSPM has blocked this website!');
    return false;
  } else {
    alert(
      'JSPrintManager (JSPM) is not installed or not running.\n' +
        'If JSPM is already installed and running on your system, please refresh the page.\n' +
        'Download JSPM Client App from https://www.neodynamic.com/downloads/jspm\n',
    );

    return false;
  }
};

export { initJSPM, jspmWSStatus };
